import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1847a33d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pagination-container" }
const _hoisted_2 = { class: "text-center mb-2" }
const _hoisted_3 = { style: {"position":"relative","min-height":"120px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }

import { ref, computed, watch, onMounted } from "vue";
import debounce from "lodash/debounce";
import TorneoCard from "@/components/Torneos/TorneoCard.vue";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import {
  getTorneosPasadosPaginadosAsync,
  getTorneosProximosPaginadosAsync,
  buscarTorneosPorNombreAsync,
} from "@/services/TorneosService";
import { Torneo } from "@/interfaces/Torneo";
import { diaDeHoy, ultimoDiaEvento } from "@/utils/Fecha";

// Como en el back: un evento ha terminado si su último día ya pasó. Se comparan días, no horas: el de hoy aún no

export default /*#__PURE__*/_defineComponent({
  __name: 'TorneosView',
  setup(__props) {

const haTerminado = (torneo: Torneo) =>
  ultimoDiaEvento(torneo.fechaInicioTorneo, torneo.fechaFinTorneo) < diaDeHoy();

const isLoading = ref(true);
const tab = ref("proximos");
const searchQuery = ref("");
const currentPage = ref(1);
const pageSize = ref(6);

// Estado para próximos
const torneosProximos = ref<Torneo[]>([]);
const totalPagesProximos = ref(1);
const totalCountProximos = ref(0);

// Estado para pasados
const torneosPasados = ref<Torneo[]>([]);
const totalPagesPasados = ref(1);
const totalCountPasados = ref(0);

const fetchTorneosProximos = async () => {
  isLoading.value = true;
  try {
    if (searchQuery.value) {
      const res = await buscarTorneosPorNombreAsync(searchQuery.value);
      torneosProximos.value = res.data.filter((t: Torneo) => !haTerminado(t));
      totalPagesProximos.value = Math.max(
        1,
        Math.ceil(torneosProximos.value.length / pageSize.value)
      );
      totalCountProximos.value = torneosProximos.value.length;
    } else {
      const res = await getTorneosProximosPaginadosAsync(
        currentPage.value,
        pageSize.value
      );
      torneosProximos.value = res.data.items;
      totalPagesProximos.value = res.data.totalPages;
      totalCountProximos.value = res.data.totalCount;
    }
  } finally {
    isLoading.value = false;
  }
};

const fetchTorneosPasados = async () => {
  isLoading.value = true;
  try {
    if (searchQuery.value) {
      const res = await buscarTorneosPorNombreAsync(searchQuery.value);
      torneosPasados.value = res.data.filter((t: Torneo) => haTerminado(t));
      totalPagesPasados.value = Math.max(
        1,
        Math.ceil(torneosPasados.value.length / pageSize.value)
      );
      totalCountPasados.value = torneosPasados.value.length;
    } else {
      const res = await getTorneosPasadosPaginadosAsync(
        currentPage.value,
        pageSize.value
      );
      torneosPasados.value = res.data.items;
      totalPagesPasados.value = res.data.totalPages;
      totalCountPasados.value = res.data.totalCount;
    }
  } finally {
    isLoading.value = false;
  }
};

// Watchers para recargar según pestaña y página
watch(tab, async newTab => {
  currentPage.value = 1;
  if (newTab === "proximos") {
    await fetchTorneosProximos();
  } else {
    await fetchTorneosPasados();
  }
});

watch(currentPage, async () => {
  if (tab.value === "proximos") {
    await fetchTorneosProximos();
  } else {
    await fetchTorneosPasados();
  }
});

// Búsqueda reactiva con debounce
const debouncedBuscar = debounce(async () => {
  currentPage.value = 1;
  if (tab.value === "proximos") {
    await fetchTorneosProximos();
  } else {
    await fetchTorneosPasados();
  }
}, 400);

watch(searchQuery, () => {
  debouncedBuscar();
});

// Inicialización
onMounted(async () => {
  if (tab.value === "proximos") {
    await fetchTorneosProximos();
  } else {
    await fetchTorneosPasados();
  }
});

// Computed para búsqueda solo sobre la página actual de pasados
const filteredTorneosPasados = computed(() => {
  if (!searchQuery.value) return torneosPasados.value;
  return torneosPasados.value.filter(torneo =>
    torneo.nombreTorneo.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

const resetPage = () => {
  currentPage.value = 1;
};

// Computed para la paginación y datos actuales
const paginatedTorneosProximos = computed(() => torneosProximos.value);
const paginatedTorneosPasados = computed(() => filteredTorneosPasados.value);
const totalPages = computed(() =>
  tab.value === "proximos" ? totalPagesProximos.value : totalPagesPasados.value
);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { dense: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "text-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_tabs, {
                modelValue: tab.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
                color: "primary",
                grow: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tab, { value: "proximos" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Próximos ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tab, { value: "pasados" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Pasados ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_container, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "8",
                        "offset-sm": "2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: searchQuery.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                            label: "Buscar evento",
                            clearable: "",
                            tonal: "",
                            dense: "",
                            "append-icon": "mdi-magnify",
                            class: "elevated-search",
                            onInput: resetPage
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_pagination, {
                  modelValue: currentPage.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentPage).value = $event)),
                  length: totalPages.value,
                  class: "mb-4 justify-center",
                  size: tab.value === 'proximos' ? 'large' : 'small',
                  color: "primary",
                  variant: "tonal",
                  disabled: 
              (tab.value === 'proximos'
                ? paginatedTorneosProximos.value.length
                : paginatedTorneosPasados.value.length) === 0
            
                }, null, 8, ["modelValue", "length", "size", "disabled"]),
                _createElementVNode("p", _hoisted_2, " Página " + _toDisplayString(currentPage.value) + " de " + _toDisplayString(totalPages.value), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                (isLoading.value)
                  ? (_openBlock(), _createBlock(LoadingGandalf, {
                      key: 0,
                      style: {"position":"absolute","left":"0","right":"0","z-index":"2"}
                    }))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (tab.value === 'proximos')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (paginatedTorneosProximos.value.length < 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No hay eventos próximos. "))
                              : (_openBlock(), _createBlock(_component_v_row, {
                                  key: 1,
                                  dense: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTorneosProximos.value, (torneo) => {
                                      return (_openBlock(), _createBlock(_component_v_col, {
                                        key: torneo.idTorneo,
                                        cols: "12",
                                        sm: "6",
                                        md: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(TorneoCard, {
                                            torneo: torneo,
                                            verClasificacion: false
                                          }, null, 8, ["torneo"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (paginatedTorneosPasados.value.length < 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No hay eventos pasados con esa búsqueda. "))
                              : (_openBlock(), _createBlock(_component_v_row, {
                                  key: 1,
                                  dense: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedTorneosPasados.value, (torneo) => {
                                      return (_openBlock(), _createBlock(_component_v_col, {
                                        key: torneo.idTorneo,
                                        cols: "12",
                                        sm: "8",
                                        md: "6",
                                        lg: "4"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(TorneoCard, {
                                            torneo: torneo,
                                            verClasificacion: true
                                          }, null, 8, ["torneo"])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }))
                          ], 64))
                    ], 64))
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})